import React from "react";
import { Button, Space, Popconfirm } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import DataTable from "../../../components/DataTable";

export default function SkeyeingestExecutorTable({
  data,
  loading,
  page,
  pageSize,
  onPageChange,
  onDeleteExecutor,
  isRoleUser,
}) {
  const columns = [
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
      width: "30%",
      sorter: (a, b) =>
        (a.id || "").toString().localeCompare((b.id || "").toString()),
    },
    {
      title: "File Name",
      dataIndex: "filename",
      key: "filename",
      width: "55%",
      sorter: (a, b) => (a.filename || "").localeCompare(b.filename || ""),
    },
  ];

  if (!isRoleUser) {
    columns.push({
      title: "Actions",
      key: "actions",
      width: "15%",
      render: (_, record) => (
        <Space size="middle">
          <Popconfirm
            title="Delete Executor"
            description="Are you sure you want to delete this executor?"
            okText="Yes, Delete"
            cancelText="Cancel"
            okButtonProps={{ danger: true }}
            onConfirm={() => onDeleteExecutor(record.id)}
          >
            <Button
              type="text"
              danger
              icon={<DeleteOutlined />}
              title="Delete Executor"
            />
          </Popconfirm>
        </Space>
      ),
    });
  }

  return (
    <DataTable
      rowKey="id"
      columns={columns}
      data={data}
      loading={loading}
      page={page}
      pageSize={pageSize}
      onPageChange={onPageChange}
    />
  );
}
